import React from 'react';
import { classes, st } from './Header.st.css';
import { Filters } from '../../../../shared/components/Filters/Filters';
import { useWidgetViewModel } from '../../hooks/useWidgetViewModel';
import { WeeklyDatepicker } from '../../../../shared/components/WeeklyDatepicker/WeeklyDatepicker';
import { Title } from '../../../../shared/components/Title/Title';
import { Timezone } from '../../../../shared/components/Timezone/Timezone';
import { HeaderDataHooks } from './const';
import { Spinner } from '../../../../shared/components/Spinner/Spinner';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { FiltersModal } from '../../../../shared/components/Filters/FiltersModal/FiltersModal';

export const Header: React.FC = () => {
  const {
    isInitDataLoading,
    titleViewModel,
    filtersViewModel,
    timeZoneViewModel,
  } = useWidgetViewModel();

  const { isMobile, isRTL } = useEnvironment();

  const HeaderContent = () => (
    <div className={classes.mobileHeaderContent}>
      <Title titleViewModel={titleViewModel} />
      {isMobile && (
        <FiltersModal
          filtersViewModel={filtersViewModel}
          timeZoneViewModel={timeZoneViewModel}
        />
      )}
    </div>
  );

  const DesktopFilters = () => (
    <div className={classes.filters} data-hook={HeaderDataHooks.FiltersWrapper}>
      <Timezone timeZoneViewModel={timeZoneViewModel} />
      <Filters filtersViewModel={filtersViewModel} />
    </div>
  );

  if (isInitDataLoading) {
    return (
      <div className={classes.root} data-hook={HeaderDataHooks.Main}>
        <HeaderContent />
        <Spinner
          className={classes.spinner}
          show={true}
          dataHook={HeaderDataHooks.HeaderSpinner}
        />
      </div>
    );
  }
  return (
    <div
      className={st(classes.root, { isMobile, isRTL })}
      data-hook={HeaderDataHooks.Main}
    >
      <HeaderContent />
      <div
        className={classes.filtersContainer}
        data-hook={HeaderDataHooks.FiltersContainer}
      >
        <div
          className={classes.weeklyDatePicker}
          data-hook={HeaderDataHooks.WeeklyDatepickerContainer}
        >
          <WeeklyDatepicker />
        </div>
        {!isMobile && <DesktopFilters />}
      </div>
    </div>
  );
};
